import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import leftArrowIcon from '../../assets/img/iconLeft.svg';
import rightArrowIcon from '../../assets/img/iconRight.svg';

function TablePagination({ onOffsetChange, offset, pageSize, total }) {
  const prevEnabled = offset !== 0;
  const nextEnabled = (offset + 1) * pageSize < total;

  const currentPage = Math.ceil(offset || 0);
  const pages = _.range(total / pageSize);

  const closestPages =
    pages.size < 5 ? pages : pages.filter((page) => Math.abs(currentPage - page) <= 2);
  const hasPreviousPages = pages.some((page) => page < _.min(closestPages));
  const hasNextPages = pages.some((page) => page > _.max(closestPages));

  return (
    <Pagination>
      <PaginationItem disabled={!prevEnabled}>
        <PaginationLink
          onClick={() => onOffsetChange(offset - 1)}
          type="button"
          className="page-link__prev"
        >
          <img
            src={leftArrowIcon}
            alt="Page Left"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(8%) sepia(100%) saturate(1000%) hue-rotate(240deg) brightness(0.2) contrast(100%)',
              opacity: prevEnabled ? 1 : 0.1,
            }}
          />
        </PaginationLink>
      </PaginationItem>
      {hasPreviousPages && <span className="page-link__dots">...</span>}
      {closestPages.map((page, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <PaginationItem active={page === currentPage} key={index}>
          <PaginationLink
            onClick={() => onOffsetChange(page)}
            type="button"
            className="page-link__page"
          >
            {page + 1}
          </PaginationLink>
        </PaginationItem>
      ))}
      {hasNextPages && <span className="page-link__dots">...</span>}
      <PaginationItem disabled={!nextEnabled}>
        <PaginationLink
          onClick={() => onOffsetChange(offset + 1)}
          type="button"
          className="page-link__next"
        >
          <img
            src={rightArrowIcon}
            alt="Page Right"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(8%) sepia(100%) saturate(1000%) hue-rotate(240deg) brightness(0.2) contrast(100%)',
              opacity: nextEnabled ? 1 : 0.1,
            }}
          />
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  );
}

TablePagination.defaultProps = {
  offset: 0,
  pageSize: 10,
  total: 0,
};

TablePagination.propTypes = {
  onOffsetChange: PropTypes.func.isRequired,
  offset: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
};

export default TablePagination;
